import { useEffect, useState } from "react";
import { ILocationProps } from "../services/Location/types";

export function useLocationStream(url: string) {
    const [locations, setLocations] = useState<ILocationProps[]>([]);

    useEffect(() => {
        const ws = new WebSocket(url);

        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                if (Array.isArray(data)) {
                    setLocations(data);
                    return;
                }
                if (!data.entityId) return;

                setLocations(prev => {
                    const idx = prev.findIndex(l => l.entityId === data.entityId);
                    if (idx >= 0) {
                        const updated = [...prev];
                        updated[idx] = data;
                        return updated;
                    }
                    return [...prev, data];
                });
            } catch (err) {
                console.error("Invalid WS payload", err);
            }
        };

        ws.onclose = () => {
            console.warn("WebSocket closed");
        };

        return () => {
            ws.close();
        };
    }, [url]);

    return locations;
}
